const awsmobile = {
  switching_endpoint: "https://api-qa.switching.preview.trustpower.io",
  api_key: "6fcb620f891e4b53c30e438da391c5caLXFh",
};

export default awsmobile;
